import React from 'react'
import { Jumbotron, Button } from 'react-bootstrap/lib'
import './jumbotron.css';

export default () => {
  return (
    <div className="jumbotron-wrapper">
      <Jumbotron>
          <h1>Hello, world!</h1>
          <p>
            This is a simple hero unit, a simple jumbotron-style component for calling
            extra attention to featured content or information.
          </p>
          <p>
            <Button bsStyle="primary">Learn more</Button>
          </p>
      </Jumbotron>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/jumbotron/index.js